import {memo, useEffect} from 'react';
import {createGlobalStyle} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any} from 'prop-types';
import {ColorThemeContext} from 'r/contexts';
import {useStateReducer} from 'r/utils';
import {colors} from 'r/Design/Colors';
import {StoredIsColorThemeDark} from 'r/utils/Stored';


const Colors = createGlobalStyle`
  :root {
    ${props => Object.entries(colors).map(([key, value]) => `--${key.match(/var\(--(.*)\)/)[1]}: ${!Array.isArray(value) ? value : !props.$isColorThemeDark ? value[0] : value[1]};`).join(' ')}
  }
`;

export default memo(ColorThemeProvider);

ColorThemeProvider.propTypes = forbidExtraProps({
  children: any.isRequired,
});

function ColorThemeProvider({
  children,
}) {
  const [{
    isColorThemeDark,
  }, ss] = useStateReducer({
    isColorThemeDark: StoredIsColorThemeDark.get(),
  });

  const switchColorTheme = () => {
    StoredIsColorThemeDark.set(!isColorThemeDark);
    ss({isColorThemeDark: !isColorThemeDark});
  };

  const value = {
    switchColorTheme,
    isColorThemeDark,
  };

  useEffect(() => {
    window.__r__debugColorThemeContextValue = value; // eslint-disable-line no-restricted-syntax
  }, [value]);


  return (
    <>
      <Colors $isColorThemeDark={isColorThemeDark}/>
      <ColorThemeContext.Provider value={value}>
        {children}
      </ColorThemeContext.Provider>
    </>
  );
}
